import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

declare const $;

@Injectable()
export class EdsService {
  webSocket = null;
  heartbeat_msg = '--heartbeat--';
  heartbeat_interval = null;
  missed_heartbeats = 0;
  missed_heartbeats_limit_min = 3;
  missed_heartbeats_limit_max = 50;
  missed_heartbeats_limit = this.missed_heartbeats_limit_min;
  callback = null;

  constructor(private _http: HttpClient) {
    this.init();
  }


  init() {
    console.log('init ncalayer');
    const that = this;

    this.webSocket = new WebSocket('wss://127.0.0.1:13579/');
    this.webSocket.onopen = function (event) {
      if (that.heartbeat_interval === null) {
        that.missed_heartbeats = 0;
        that.heartbeat_interval = setInterval(that.pingLayer, 2000);
      }
      console.log('Connection opened');
    };

    this.webSocket.onclose = function (event) {
      if (event.wasClean) {
        console.log('connection has been closed');
      } else {
        console.log('Connection error');
        //   openDialog();
      }
      console.log('Code: ' + event.code + ' Reason: ' + event.reason);
    };

    this.webSocket.onmessage = function (event) {
      if (event.data === that.heartbeat_msg) {
        that.missed_heartbeats = 0;
        return;
      }

      const result = JSON.parse(event.data);

      if (result != null) {
        const rw = {
          code: result['code'],
          message: result['message'],
          responseObject: result['responseObject'],
          getResult: function () {
            return this.result;
          },
          getMessage: function () {
            return this.message;
          },
          getResponseObject: function () {
            return this.responseObject;
          },
          getCode: function () {
            return this.code;
          }
        };
        if (typeof that.callback == 'function') {
          that.callback(rw);
        }
      }
      console.log(event);
      that.setMissedHeartbeatsLimitToMin();
    };
  }

  setMissedHeartbeatsLimitToMax() {
    this.missed_heartbeats_limit = this.missed_heartbeats_limit_max;
  }

  setMissedHeartbeatsLimitToMin() {
    this.missed_heartbeats_limit = this.missed_heartbeats_limit_min;
  }

  blockScreen() {
    // $.blockUI({
    //   message: '<img src="js/loading.gif" /><br/>Подождите, идет загрузка Java-апплета...',
    //   css: {
    //     border: 'none',
    //     padding: '15px',
    //     backgroundColor: '#000',
    //     '-webkit-border-radius': '10px',
    //     '-moz-border-radius': '10px',
    //     opacity: .5,
    //     color: '#fff'
    //   }
    // });
  }

  openDialog() {
    if (confirm('Ошибка при подключений к прослойке NCALayer. Убедитесь что программа NCALayer запущена и нажмите ОК') === true) {
      this.init();
    }
  }

  unBlockScreen() {
    // $.unblockUI();
  }


  activateWebSocket() {
    if (this.webSocket.readyState === this.webSocket.CLOSED) {
      this.openDialog();
    }
  }

  pingLayer() {
    try {
      this.missed_heartbeats++;
      if (this.missed_heartbeats >= this.missed_heartbeats_limit) {
        throw new Error('Too many missed heartbeats.');
      }
      this.webSocket.send(this.heartbeat_msg);
    } catch (e) {
      clearInterval(this.heartbeat_interval);
      this.heartbeat_interval = null;
      console.warn('Closing connection. Reason: ' + e.message);
      this.webSocket.close();
    }
  }

  getActiveTokens(callBack) {
    const getActiveTokens = {
      'module': 'kz.gov.pki.knca.commonUtils',
      'method': 'getActiveTokens'
    };
    this.callback = callBack;
    this.setMissedHeartbeatsLimitToMax();
    this.webSocket.send(JSON.stringify(getActiveTokens));
  }

  getKeyInfo(storageName, callBack) {
    const getKeyInfo = {
      'module': 'kz.gov.pki.knca.commonUtils',
      'method': 'getKeyInfo',
      'args': [storageName]
    };
    this.callback = callBack;
    this.setMissedHeartbeatsLimitToMax();
    this.webSocket.send(JSON.stringify(getKeyInfo));
  }

  signXml(storageName, keyType, xmlToSign, fn) {
    const signXml = {
      'module': 'kz.gov.pki.knca.commonUtils',
      'method': 'signXml',
      'args': [storageName, keyType, xmlToSign, '', '']
    };
    this.callback = fn;
    this.setMissedHeartbeatsLimitToMax();
    this.webSocket.send(JSON.stringify(signXml));
  }

  createCMSSignatureFromFile(storageName, keyType, filePath, flag, callBack) {
    const createCMSSignatureFromFile = {
      'module': 'kz.gov.pki.knca.commonUtils',
      'method': 'createCMSSignatureFromFile',
      'args': [storageName, keyType, filePath, flag]
    };
    this.callback = callBack;
    this.setMissedHeartbeatsLimitToMax();
    this.webSocket.send(JSON.stringify(createCMSSignatureFromFile));
  }

  showFileChooser(fileExtension, currentDirectory, callBack) {
    const showFileChooser = {
      'module': 'kz.gov.pki.knca.commonUtils',
      'method': 'showFileChooser',
      'args': [fileExtension, currentDirectory]
    };
    this.callback = callBack;
    this.setMissedHeartbeatsLimitToMax();
    this.webSocket.send(JSON.stringify(showFileChooser));
  }


  /*   calss */


  getActiveTokensCall() {
    this.getActiveTokens('getActiveTokensBack');
  }

  getActiveTokensBack(result) {
    if (result['code'] === '500') {
      alert(result['message']);
    } else if (result['code'] === '200') {
      const listOfTokens = result['responseObject'];
      $('#storageSelect').empty();
      $('#storageSelect').append('<option value="PKCS12">PKCS12</option>');
      for (let i = 0; i < listOfTokens.length; i++) {
        $('#storageSelect').append('<option value="' + listOfTokens[i] + '">' + listOfTokens[i] + '</option>');
      }
    }
  }

  getKeyInfoCall() {
    const selectedStorage = $('#storageSelect').val();
    this.getKeyInfo(selectedStorage, 'getKeyInfoBack');
  }

  getKeyInfoBack(result) {
    if (result['code'] === '500') {
      alert(result['message']);
    } else if (result['code'] === '200') {
      const res = result['responseObject'];

      const alias = res['alias'];
      $('#alias').val(alias);

      const keyId = res['keyId'];
      $('#keyId').val(keyId);

      const algorithm = res['algorithm'];
      $('#algorithm').val(algorithm);

      const subjectCn = res['subjectCn'];
      $('#subjectCn').val(subjectCn);

      const subjectDn = res['subjectDn'];
      $('#subjectDn').val(subjectDn);

      const issuerCn = res['issuerCn'];
      $('#issuerCn').val(issuerCn);

      const issuerDn = res['issuerDn'];
      $('#issuerDn').val(issuerDn);

      const serialNumber = res['serialNumber'];
      $('#serialNumber').val(serialNumber);

      let dateString = res['certNotAfter'];
      let date = new Date(Number(dateString));
      $('#notafter').val(date.toLocaleString());
      $('#notafter_long').val(date.getTime());

      dateString = res['certNotBefore'];
      date = new Date(Number(dateString));
      $('#notbefore').val(date.toLocaleString());
      $('#notbefore_long').val(date.getTime());

      const authorityKeyIdentifier = res['authorityKeyIdentifier'];
      $('#authorityKeyIdentifier').val(authorityKeyIdentifier);

      const pem = res['pem'];
      $('#pem').val(pem);
    }
  }

  signXmlCall(xmlToSign, fn) {
    this.activateWebSocket();
    // const selectedStorage = $('#storageSelect').val();
    const selectedStorage = 'PKCS12';
    // $.blockUI();
    this.signXml(selectedStorage, 'SIGNATURE', xmlToSign, (result) => {
      if (result['code'] === '500') {
        // alert(result['message']);
      } else if (result['code'] === '200') {
        const res = result['responseObject'];
        fn(res);
      }
    });
  }

  signXmlBack(result) {
    // $.unblockUI();
    if (result['code'] === '500') {
      // alert(result['message']);
    } else if (result['code'] === '200') {
      const res = result['responseObject'];
      $('#signedXml').val(res);
    }
  }

  createCMSSignatureFromFileCall() {
    const selectedStorage = $('#storageSelect').val();
    const flag = $('#flag').is(':checked');
    const filePath = $('#filePath').val();
    if (filePath !== null && filePath !== '') {
      // $.blockUI();
      this.createCMSSignatureFromFile(selectedStorage, 'SIGNATURE', filePath, flag, 'createCMSSignatureFromFileBack');
    } else {
      alert('Не выбран файл для подписи!');
    }
  }

  createCMSSignatureFromFileBack(result) {
    // $.unblockUI();
    if (result['code'] === '500') {
      alert(result['message']);
    } else if (result['code'] === '200') {
      const res = result['responseObject'];
      $('#createdCMS').val(res);
    }
  }

  showFileChooserCall() {
    this.showFileChooser('ALL', '', 'showFileChooserBack');
  }

  showFileChooserBack(result) {
    if (result['code'] === '500') {
      alert(result['message']);
    } else if (result['code'] === '200') {
      const res = result['responseObject'];
      $('#filePath').val(res);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/services/eds.service.ts